import React, { useContext, useEffect, useState } from "react";
import { Card, Form, Input, Modal, Space, Table, Tooltip, Upload } from "antd";
import { userprofile } from "hooks/api/myplanapi";
import useGetData from "components/common/useGetData";
import ToastMsg from "components/common/ToastMsg";
import MyButton from "components/ui/Button/MyButton";
import { AuthContext } from "context/auth/authentication";
import { USER_PROFILE, PROFILE_CHANGE_PASSWORD } from "constants";
import { Navigate, useNavigate } from "react-router-dom";
import { noBlankSpacesValidator, passwordValidator } from "components/common/validation";

const ChangePassword = () => {
    const authtoken = sessionStorage.getItem("token");
    const [isNotifyPopup, setIsNotifyPop] = useState(false);
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const is_password_updated = JSON.parse(sessionStorage.getItem("is_password_updated"));
    const { logoutauth } = useContext(AuthContext);
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        current_password: "",
        new_password: "",
        confirm_password: "",
    });

    useEffect(() => {
        if (!is_password_updated) {
            setIsNotifyPop(true);
        }
    }, [is_password_updated])

    const handleChange = (name, value) => {
        setFormData({
            ...formData,
            [name]: value,
        });
        form.setFieldsValue({
            ...formData,
            [name]: value,
        });
        triggerFieldValidation(name);
    };

    const triggerFieldValidation = (fieldName) => {
        form.validateFields([[fieldName]]);
    };

    const changePasswordNotify = () => {
        return (
            <Modal
                centered
                open={true}
                footer={null}
                width={"20vw"}
                height={"10vw"}
                className="custom-modal"
                closable={false}
            >
                <p id="common_weekoffTxt">Kindly change your password for further process</p>
                <div className='flex justify-end items-center  mt-5'>
                    <MyButton htmlType="button" label="ok" onClick={popupcancel} outlined={true} paddingX={"0 1.2vw"} marginRight={"0.625vw"} />
                </div>
            </Modal>
        )
    }

    const popupcancel = () => {
        setIsNotifyPop(false);
    }

    const renderInput = (label, statekey, testID = '', maxLength = 150, required = false) => {
        return (
            <>
                <div className='commonInputTlt'>{label} {required ? <span className='requiredTxt'>*</span> : null}</div>
                <Input.Password
                    autoComplete='off'
                    style={styles.textField}
                    type={"text"}
                    name={statekey}
                    value={formData[statekey]}
                    onChange={(e) => handleChange(e.target.name, e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === ' ') {
                            e.preventDefault();
                        }
                    }}
                    data-testID={testID}
                />
            </>
        )
    }

    const handlesave = () => {
        if (formData.confirm_password === formData.new_password) {
            try {
                setLoading(true)
                const dataForm = new FormData();
                dataForm.append("current_password", formData.current_password ? formData.current_password : "");
                dataForm.append("new_password", formData.new_password ? formData.new_password : "");
                fetch(PROFILE_CHANGE_PASSWORD, {
                    method: "POST",
                    headers: {
                        'Authorization': `token ${authtoken}`
                    },
                    body: dataForm
                })
                    .then((response) => response.json())
                    .then(async data => {
                        if (data.status === "success") {
                            ToastMsg("success", data.message);
                            setLoading(false);
                            setFormData({
                                current_password: "",
                                new_password: "",
                                confirm_password: "",
                            })
                            logoutauth();
                            navigate("/");
                        }
                        else if (data.status === "fail") {
                            setLoading(false);
                            ToastMsg("error", data.message);
                        }
                    })
                    .catch(error => {
                        setLoading(false);
                        ToastMsg("error", error.message);
                    });
            } catch (error) {
                ToastMsg("error", error.message);
            }
        }
        else {
            ToastMsg("error", "Confirm password should be same");
        }
    }

    return (
        <div className="p-3 bg-white rounded-lg shadow-md h-full">
            <h2 className="text-sm font-semibold border-b pb-2 mb-4">Change Password</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

                {/* Left Section: Form */}
                <div className="md:col-span-2">
                    <Form
                        layout="vertical"
                        form={form}
                        requiredMark={true}
                        name="changePasswordForm"
                        onFinish={handlesave}
                        className="h-full"
                    >
                        <Form.Item
                            style={styles.formItem}
                            name="current_password"
                            rules={[{ required: true, validator: noBlankSpacesValidator }]}
                        >
                            {renderInput('Current Password', "current_password", 'current_pass', 50, true)}
                        </Form.Item>

                        <Form.Item
                            style={styles.formItem}
                            name="new_password"
                            rules={[{ required: true, validator: passwordValidator }]}
                        >
                            {renderInput('New Password', "new_password", '', 50, true)}
                        </Form.Item>

                        <Form.Item
                            style={styles.formItem}
                            name="confirm_password"
                            rules={[{ required: true, validator: passwordValidator }]}
                        >
                            {renderInput('Confirm Password', "confirm_password", 'doc_name', 50, true)}
                        </Form.Item>

                        <div className="mt-6">
                            <MyButton htmlType="submit" label="Save Changes" paddingX="0 1vw" />
                        </div>

                        {isNotifyPopup && changePasswordNotify()}
                    </Form>
                </div>

                {/* Right Section: Info Panel */}
                <div className="border-l pl-6 text-[13px]">
                    <h3 className="text-sm font-semibold border-b pb-2 mb-4">Password Information</h3>

                    <div className="mb-4">
                        <p className="font-medium">Password Expiration Notice</p>
                        <p className="text-xs text-gray-600">Your password will expire in 45 days.</p>
                    </div>

                    <div className="mb-4">
                        <p className="font-medium">Action Required</p>
                        <p className="text-xs text-gray-600">Please change your password before it expires to maintain access.</p>
                    </div>

                    <div className="mb-4">
                        <p className="font-medium">After Expiration</p>
                        <p className="text-xs text-gray-600">Once expired, you must update your password to log in again.</p>
                    </div>

                    <div>
                        <p className="font-medium">Security Reminder</p>
                        <p className="text-xs text-gray-600">Use a strong password combining letters, numbers, and special characters.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

const styles = {
    textField: {
        width: "23vw"
    },
    formItem: {
        margin: "1vw"
    },
    emptyFormItem: {
        width: "23vw",
        margin: "1vw"
    }
}

export default ChangePassword;